import React from "react"
import { cn } from "../lib/utils"

export function DisplayInput({ value, className, ...props }) {
  return (
    <div
      className={cn(
        "flex h-9 w-full min-w-0 rounded-md border border-input bg-muted/50 px-3 py-2 text-sm truncate",
        className
      )}
      title={value}
      {...props}
    >
      {value ?? "-"}
    </div>
  )
}